<template>
    <div class="fixed inset-0 z-[9999] grid place-items-center bg-white">
        <div class="flex flex-col items-center gap-4">
            <!-- Ring spinner -->
            <div class="relative h-14 w-14">
                <span
                    class="absolute inset-0 border-4 border-gray-200 rounded-full opacity-70"
                ></span>
                <span
                    class="absolute inset-0 border-4 border-transparent rounded-full border-t-gray-800 animate-spin-smooth"
                ></span>
            </div>

            <!-- (opsional) logo kecil di tengah spinner -->
            <!--
                <img :src="logoSrc" alt="Logo" class="absolute w-6 h-6" />
            -->

            <!-- <p class="text-sm text-gray-600">{{ message }}</p> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseLoadingScreen",
    props: {
        message: { type: String, default: "Loading..." },
        logoSrc: {
            type: String,
            default() {
                // ganti bila mau menaruh logo kecil di tengah spinner
                return "";
            },
        },
    },
};
</script>

<style scoped>
@keyframes spin-smooth {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.animate-spin-smooth {
    animation: spin-smooth 0.9s linear infinite;
}
</style>
